import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// ✅ 双挂载逻辑：优先 #qiyiju-olive-chat（WP注入），否则退回 #root（独立 /chat 页）
const mountPoint =
  document.getElementById('qiyiju-olive-chat') ||
  document.getElementById('root');

if (mountPoint) {
  const root = ReactDOM.createRoot(mountPoint);
  root.render(<App />);
} else {
  console.error("❌ 挂载点 #qiyiju-olive-chat 或 #root 未找到！");
}

reportWebVitals();

